import { SettingsAccountPage } from "@/components/settings/account/account";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/settings/account")({
  component: SettingsAccountPage,
});
